// extracted by mini-css-extract-plugin
module.exports = {"container":"DashBoard_container__bzz7u"};